module Core {
    export enum PaymentType {
        Classic,
        Deffered,
        Immediate
    }
}